<template>
  <VModal name="remove-payment-method-modal" :loading="loading">
    <template v-slot:header>
      <h2 class="o-modal__box__header">{{ $t('companySettings.billing.paymentMethods.removePaymentMethod') }}</h2>
    </template>
    <template v-slot:content>
      <VForm :onSubmit="deleteMethod">
        <div slot="row">
          <p>{{ $t('companySettings.billing.paymentMethods.removePaymentMethodMessage') }}</p>
        </div>
        <div slot="formButtons">
          <VButton
              type="error"
              class="float-right"
              subtype="submit"
              href="#"
              data-ec="billing_remove_payment_method_modal"
              data-et="delete_button">
            <TrashIcon />
            <span>{{ $t('functional.delete') }}</span>
          </VButton>
        </div>
      </VForm>
    </template>
  </VModal>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import { TrashIcon } from '@/components/icons/fontIcons';

export default {
  name: 'RemovePaymentMethodModal',
  inject: {
    $validator: '$validator',
  },
  components: {
    VButton,
    VForm,
    VModal,
    TrashIcon,
  },
  props: {
    method: {
      type: [String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    deleteMethod() {
      this.loading = true;

      this.$store.dispatch('paymentMethods/DELETE_METHOD', { id: this.method.toString() }).then(() => {
        this.$bus.$emit('closeModal');
      }).finally(() => {
        this.loading = false;
      });
    },
    modalBack() {
      this.$bus.$emit('closeModal');
    },
  },
};
</script>
